import { useNavigate } from "react-router";

import ItemFolio from "../components/ItemFolio";
import TitleHero from "../components/ui/TitleHero";
import Loading from "componentsv2/widgets/Loading";

const Folios = ({ folios, isLoading, configHotel }) => {
  const navigate = useNavigate();

  function handleOpenModalLang(folio) {
    navigate(folio?.id.toString());
  }

  return (
    <div>
      <TitleHero
        name={null}
        desc="msg-introduction"
        logo={configHotel.value?.["company."]?.logo_link}
        style="!max-w-[737px]"
      />

      {isLoading.value && <Loading />}

      {folios.length > 0 ? (
        <div className="grid grid-cols-2 max-md:gap-x-4 md:grid-cols-6 gap-y-4 max-w-[914px] mx-auto mt-[30px]">
          {folios.map((folio, index) => (
            <ItemFolio
              id={folio.id}
              title={folio["room."].name}
              desc={folio["booking."].number}
              channel={folio["channel."]?.code}
              handleClick={() => handleOpenModalLang(folio)}
              key={index}
            />
          ))}
        </div>
      ) : (
        <p className="text-center mt-10 font-bold">No hay folios</p>
      )}
    </div>
  );
};

export default Folios;
